import React from 'react';
import {getHistory} from '@assets/components/filemanager/src/helper';

class FileLogBtn extends React.Component {
    constructor(props) {
        super(props);
    }

    showModalHistory() {
        let data = {
            fieldName: this.props.fieldName,
            tableId: this.props.tableId,
            rowId: this.props.rowId,
            title: this.props.title,
        };
        getHistory(data);
    }

    render() {
        return (
            <button onClick={(e) => this.showModalHistory(e)}
                    type="button" className="btn btn-info btn-xs log-files"
                    data-toggle="tooltip" data-placement="top" title="История изменения файлов"
                    data-trigger="hover">
                <b>H</b>
            </button>
        );
    }
}
export default FileLogBtn;